export const getAddressStreet = (str = '') => {
  const idx = str.indexOf(',')
  return str.substring(0, idx).trim()
}

export const getAddressNumber = (str = '') => {
  const idx = str.indexOf(',')
  let idx2 = str.indexOf('-')
  idx2 = idx2 === -1 ? str.length : idx2
  return str.substring(idx + 1, idx2).trim()
}

export const getAddressComplement = (str = '') => {
  const idx = str.indexOf('-')
  if (idx === -1) {
    return ''
  }
  return str.substring(idx + 1).trim()
}
